export const paths = {
  USER_DASHBOARD: "/user/dashboard",
};

export const STAFF_ROUTES = {
  // CONSUMER_WALLET: "consumer-wallets",
  CONSUMER_WALLET: "walletReport",
};
